import React from 'react'
import styled from '@emotion/styled'
import { node } from 'prop-types'

const ResourceWrap = styled.div`
	background-color: #fff;
	border-top: ${({ theme }) => `.3125rem solid ${theme.colors.orange}`};
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
	margin-bottom: 1rem;
`

const ResourceContainer = styled.div`
	border-left: 1px solid rgba(0, 0, 0, 0.2);
	border-right: 1px solid rgba(0, 0, 0, 0.2);
	padding-top: 1rem;
`

const ResourceHeader = styled.div`
	font-size: 1.25rem;
	font-weight: 700;
	padding: 0 1rem 1rem 1rem;
`

ResourceSection.propTypes = {
	children: node.isRequired,
}

function ResourceSection({ children }) {
	return (
		<section>
			<ResourceWrap>
				<ResourceContainer>
					<ResourceHeader>Additional Resources</ResourceHeader>
					{children}
				</ResourceContainer>
			</ResourceWrap>
		</section>
	)
}

export default ResourceSection
